import * as React from "react";
import { TextArea as Area, useFieldState, FieldProps, useFieldApi } from "informed";
import * as classNames from 'classnames';
import { inputClasses } from "../validation/ValidationClasses";

interface TextAreaProps extends FieldProps<string, any> {
    field: string;
    inputAddon?: React.ReactNode;
}
export const TextArea = ({ field, inputAddon, ...props }: TextAreaProps) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    const divClasses = classNames({ "input-group": inputAddon !== undefined })

    return (
        <>
            <div className={divClasses}>
                <Area
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
                {inputAddon ? <span className="input-group-addon">{inputAddon}</span> : null}
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
